import { KeyConstructor } from './keyConstructor';
const COLLECTION_KEY = 'collection';
const COLLECTIONS_KEY = 'collections';
export const getCollectionKey = KeyConstructor(COLLECTION_KEY);
export const getCollectionsKey = KeyConstructor(COLLECTIONS_KEY);
//# sourceMappingURL=collection.key.js.map